/** @format */

import {TooltipText, TooltipTitle, TooltipWrapper} from './styles';

const CustomTooltip = ({active, payload}: any) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload;

    return (
      <TooltipWrapper>
        <TooltipTitle sx={{color: data.color}}>{data.name}</TooltipTitle>
        <TooltipText>Бюджет: {data.budget.toLocaleString('ru-RU')} ₽</TooltipText>
        <TooltipText>
          KPI: {data.kpi.toLocaleString('ru-RU', {maximumFractionDigits: 2})}
        </TooltipText>
      </TooltipWrapper>
    );
  }
  return null;
};

export default CustomTooltip;
